import { jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { Transition } from "react-transition-group";
import { ENTERING, ENTERED, EXITING } from "react-transition-group/Transition";
const DURATION = 350;
const defaultStyle = {
  transition: `opacity ${DURATION}ms ease-in-out`,
  opacity: 0
};
const transitionStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 }
};
const FadeOut = ({ visible, children }) => {
  const nodeRef = useRef(null);
  return /* @__PURE__ */ jsx(Transition, { nodeRef, in: visible, timeout: DURATION, children: (state) => /* @__PURE__ */ jsx(
    "div",
    {
      ref: nodeRef,
      style: {
        ...defaultStyle,
        ...transitionStyles[state]
      },
      children: [ENTERING, ENTERED, EXITING].includes(state) ? children : null
    }
  ) });
};
export {
  FadeOut
};
//# sourceMappingURL=fade-out.js.map
